<template>
  <div>
    <ul class="tabs__header">
      <li
        v-for="(tabId, index) in computedTabIds"
        :key="tabId"
        :class="{ selected: tabId == selectedId }"
        @click="selectedId = tabId"
      >
        {{ computedTabTitles[index] }}
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
import { ref, provide } from "vue";

export default {
  setup(props, { slots }) {
    const tabSlots = slots;
    const tabIds = ref(slots.default().map((tab) => tab.props.tabId));
    const selectedId = ref(tabIds.value[1]);
    provide("selectedId", selectedId);

    return {
      selectedId,
      tabIds,
      tabSlots,
    };
  },
  computed: {
    computedTabTitles() {
      return this.tabSlots.default().map((tab) => tab.props.title);
    },
    computedTabIds() {
      return this.tabSlots.default().map((tab) => tab.props.tabId);
    },
    computedSelectedId() {
      return this.computedTabIds.value[0];
    },
  },
};
</script>

<style>
.tabs {
}

.tabs__header {
  margin-bottom: 10px;
  list-style: none;
  padding: 0;
  display: flex;
}

.tabs__header li {
  width: 50%;
  text-align: center;
  border-bottom: 2px solid #c4c4c4;
  padding: 10px;
  cursor: pointer;
}

.tabs__header li.selected {
  border-bottom: 2px solid #333;
}
</style>